<div class="stats-ribbon">
  <span *ngIf="dbCreationDate">Last updated: {{dbCreationDate}}</span>
  <span *ngIf="organismStats" class="annotation-count">
    {{organismStats.annotations}} annotations
  </span>
  <span *ngIf="curatedPublicationsCount != 0" class="publication-count">
    <a routerLink="/reference_list/community">{{curatedPublicationsCount}} curated publications</a>
  </span>
</div>
